import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSetting } from '../../../../util/store/selectors';
import { ISite } from '../../../../util/varibles/interface';
import { PlanSetting } from '../../../../util/varibles/userSetting';
import { updateUserSetting } from '../../../LoginPage/reducer';
import SiteFilter from '../_components/SiteFilter';

interface IProps {
    sites: ISite[];
}

const Filter: React.FC<IProps> = ({ sites }) => {
    const {
        [PlanSetting.SMOLT_SITE]: siteFilter,
        [PlanSetting.SMOLT_PROD_AREA]: prodAreaFilter,
    } = useSelector(
        selectSetting([
            PlanSetting.SMOLT_SITE,
            PlanSetting.SMOLT_PROD_AREA,
        ])
    );

    const dispatch = useDispatch();

    const updateSetting = ({ siteFilter, prodAreaFilter, }: { siteFilter: string[]; prodAreaFilter: string[]; }) => {
        dispatch(
            updateUserSetting([{ [PlanSetting.SMOLT_SITE]: siteFilter, [PlanSetting.SMOLT_PROD_AREA]: prodAreaFilter }])
        );
    };

    return (
        <SiteFilter
            siteFilter={siteFilter || []}
            prodAreaFilter={prodAreaFilter || []}
            sites={sites}
            updateSetting={updateSetting}
        />
    );
};

export default Filter;